import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
interface StatCardProps {
  value: string | number;
  label: string;
  icon?: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  description?: string;
}
export function StatCard({
  value,
  label,
  icon,
  trend,
  description
}: StatCardProps) {
  return <div className="relative bg-[#0a0a0a] border border-gray-800 p-6 flex flex-col h-full hover:border-[#FF0000]/50 transition-all duration-300 group" data-id="element-936">
      {/* Corner Brackets */}
      <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-gray-600 group-hover:border-[#FF0000] transition-colors" data-id="element-937" />
      <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-gray-600 group-hover:border-[#FF0000] transition-colors" data-id="element-938" />
      <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-gray-600 group-hover:border-[#FF0000] transition-colors" data-id="element-939" />
      <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-gray-600 group-hover:border-[#FF0000] transition-colors" data-id="element-940" />

      <div className="flex items-start justify-between mb-4" data-id="element-941">
        <div className="p-2.5 bg-[#FF0000]/10 border border-[#FF0000] text-[#FF0000]" data-id="element-942">
          {icon}
        </div>

        {trend && <div className={`flex items-center gap-1 text-xs font-mono px-2 py-1 border ${trend.isPositive ? 'bg-green-500/10 text-green-500 border-green-500/30' : 'bg-red-500/10 text-red-500 border-red-500/30'}`} data-id="element-943">
            {trend.isPositive ? <ArrowUpRight size={12} data-id="element-944" /> : <ArrowDownRight size={12} data-id="element-945" />}
            {Math.abs(trend.value)}%
          </div>}
      </div>

      <div className="mt-auto" data-id="element-946">
        <div className="text-3xl font-black text-white tracking-tight mb-2 font-mono" data-id="element-947">
          {value}
        </div>
        <div className="text-xs font-mono text-gray-400 uppercase tracking-widest" data-id="element-948">
          {label}
        </div>
        {description && <div className="text-[10px] text-gray-600 mt-2 font-mono" data-id="element-949">
            {description}
          </div>}
      </div>
    </div>;
}